import './Navbar.css'
import {Navbar,Container,Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom'

const NavBar = () => {
  return (
    <div>
        <Navbar expand='md' bg='dark' className='sticky-top'>
                <Container>
                    <Navbar.Brand as={Link} to='/' className='text-white fw-bolder'>Chaos<span className='colorDot'>.</span></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <span className="navbar-toggler-icon"></span>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className='ms-auto'>
                            <Nav.Link className='fw-bolder Navcolor me-5' as={Link} to={'/'}> Home </Nav.Link>
                            <Nav.Link className='text-white fw-bolder NavHover' as={Link} to={'/project'}>Project</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
    </div>
  )
}

export default NavBar